import React from "react"

import _ from "lodash"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { ButtonEl } from "@components/common"
import { BUTTON_VARIANTS, BUTTON_SIZES } from "@constants/button"
import { GAMEPLAN_TYPES } from "@constants/gameplan"
import { selectUserId } from "@selectors/user"
import { showAiFeature } from "@utils/showAiFeature"
import { useSuggestionInPersonStore } from "stores/suggestions/suggestionInPersonStore"

import { useTeeUpPage } from "../../../pages/TeeUpPage/TeeUpPageContext"

import { ActionsPanel, SortIcon } from "./gameplanBlockStyles"

export const SuggestionsActions = ({
  type,
  isCollapsed,
  isDecidedSuggestion,
  isNewest,
  setIsNewest,
}) => {
  const setIsWhenModalOpen = useSuggestionInPersonStore(
    state => state.setIsWhenModalOpen
  )
  const setIsWhereModalOpen = useSuggestionInPersonStore(
    state => state.setIsWhereModalOpen
  )
  const userId = useSelector(selectUserId)
  const { openSuggestWhenAiModal } = useTeeUpPage()
  const buttonProps = {
    autoWidth: true,
    size: BUTTON_SIZES.SMALL,
    variant: BUTTON_VARIANTS.TRANSPARENT,
    textColor:
      !isCollapsed || isDecidedSuggestion ? "var(--gray2)" : "var(--gray6)",
  }
  // BUG FIX (found while wiring add-suggestion into the expanded card, TEEUP-INSIDE cleanup
  // 2026-07-03): GAMEPLAN_TYPES.when is lowercase ("when") but this component is always passed
  // the uppercase type ("WHEN"/"WHERE") from WhenWhereCard/GameplanBlock, so this comparison was
  // always false -- clicking "+ Suggest" always opened the WHERE modal, even on the When card.
  const isWhen = type === GAMEPLAN_TYPES.WHEN
  const showAi = isWhen && showAiFeature(userId)

  const handleSuggestClick = () => {
    isWhen ? setIsWhenModalOpen(true) : setIsWhereModalOpen(true)
  }

  // TEEUP-INSIDE cleanup 2026-07-03: this panel only ever mounts inside an already-expanded
  // When/Where card (GameplanBlock, rendered from WhenWhereCard when isOpen). Add-suggestion must
  // always be reachable here once suggestions already exist -- previously gated behind an
  // `isSmallSize` check (desktop never got it) AND a dead `!isCollapsed` flag whose setter was
  // never called (so it never rendered on ANY screen size). Both gates removed; "Sort by" +
  // "+ Suggest"/"AI suggest" now always render when this panel mounts.
  return (
    <ActionsPanel $isCollapsed={isCollapsed}>
      <ButtonEl
        {...buttonProps}
        text="Sort by: Newest"
        onClick={() => setIsNewest(prevState => !prevState)}>
        <SortIcon $isNewest={isNewest} name="sort" color="var(--gray2)" />
      </ButtonEl>

      {showAi && (
        <ButtonEl
          autoWidth
          variant={BUTTON_VARIANTS.TRANSPARENT}
          text="AI suggest"
          testID="aiSuggestWhenSuggestionsActions"
          onClick={openSuggestWhenAiModal}
        />
      )}

      <ButtonEl
        autoWidth
        variant={BUTTON_VARIANTS.TRANSPARENT}
        text={`+ Suggest ${_.capitalize(type)}`}
        onClick={handleSuggestClick}
      />
    </ActionsPanel>
  )
}

SuggestionsActions.propTypes = {
  isCollapsed: PropTypes.bool,
  isDecidedSuggestion: PropTypes.bool,
  isNewest: PropTypes.bool,
  setIsNewest: PropTypes.func,
}
